import { useApi } from "@utils/useApi";
import { OrdersClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import { OrdersQueryKeys } from "@features/orders-features/hooks/OrdersQueryKeys";
import ms from "ms";

export function useGetShippingDetails(
  biOrderId: number | undefined,
  webOrderId: number | undefined,
  orgUnitId: number | undefined,
) {
  const api = useApi(OrdersClient);
  const enabled = !!biOrderId || !!webOrderId;

  const fetchShippingDetails = async () => {
    return await api.getShippingDetails(biOrderId, webOrderId, orgUnitId);
  };

  return useQuery({
    queryKey: [
      OrdersQueryKeys.ShippingDetails,
      biOrderId,
      webOrderId,
      orgUnitId,
    ],
    queryFn: fetchShippingDetails,
    enabled,
    staleTime: ms("45s"),
    refetchOnWindowFocus: false,
    retry: false,
  });
}
